import React from "react";
import {UserDetails} from "../UserDetails/UserDetails";
import {userDetailsModel} from "../UserDetails/userDetailsFactory";
import {PageTitle} from "../../../Components/Landmarks";
import {LayoutHero} from "../../../Components/Layout";
import {userApi} from "../userApi";
import {locations} from "../../../Utilities/Location";
import {jobTitles} from "../../../SiteConfig/jobTitles";

interface UserRegisterContainerProps {
districts: { id: string; districtName: string }[];
    handleApiCall: (...args: unknown[]) => void;
    isLoading: boolean;
    redirect: (path: string) => void;
    setWarnings: (val: string[]) => void;
}

export const UserRegisterContainer: React.FC<UserRegisterContainerProps> = ({
                                          districts,
                                          handleApiCall,
                                          isLoading,
                                          redirect,
                                          setWarnings
                                      }) => {
    const handleRegisterUser = (registerModel: Record<string, unknown>) => {
        handleApiCall(() => userApi.attemptRegister(registerModel), () => {
            redirect(locations.LANDING.path);
        })
    };

    if (!districts)
        return null;

    return <>
        <LayoutHero>
            <PageTitle h1={`RMTC-DHH Portal Registration`}/>
            <UserDetails
                handleManageUser={handleRegisterUser}
                districts={districts}
                isLoading={isLoading}
                setWarnings={setWarnings}
                patron={userDetailsModel()}
                jobTitles={jobTitles}
            />
        </LayoutHero>
    </>;
};
